import { Attachment } from "@/types/report";
import { log } from "@/utils/logger";
import { useState } from "react";
import { ref, getDownloadURL } from "firebase/storage";
import { cloudStorage } from "@/config/firebase";
import storage from "@/utils/storage";
import mime from "mime-types";

const useDownload = ({ md5, name, mimeType }: Attachment) => {
    const [loading, setLoading] = useState(false);
    const oid = storage.getItem("oid");

    const onDownload = async () => {
        try {
            setLoading(true);
            const ext = mime.extension(mimeType);
            const pathRef = ref(cloudStorage, `organizations/${oid}/${md5}.${ext}`);
            const url = await getDownloadURL(pathRef);

            const link = document.createElement("a");
            link.target = "_blank";
            link.href = url;
            link.download = name;
            link.click();
            link.remove();
        } catch (e) {
            log.error(e);
        } finally {
            setLoading(false);
        }
    };

    return {
        downloading: loading,
        onDownload,
    };
};

export { useDownload };
